import React from 'react';

const ServicesSection = () => {
  const pricing = [
    { 
      level: "Primary Tuition", 
      price: "£25", 
      duration: "per hour",
      features: ["Ages 5-11", "KS1 & KS2", "11+ Preparation"]
    },
    { 
      level: "Secondary Tuition", 
      price: "£30", 
      duration: "per hour",
      features: ["GCSE English", "AQA & Edexcel", "Coursework Support"]
    },
    { 
      level: "A Level Tuition", 
      price: "£35", 
      duration: "per hour",
      features: ["Literature & Language", "Essay Writing", "Exam Technique"]
    },
    { 
      level: "Degree Tuition", 
      price: "£40", 
      duration: "per hour",
      features: ["University Level", "Dissertation Help", "Academic Writing"]
    }
  ];

  return (
    <section id="services" className="section-padding bg-beige">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-black mb-6 text-center">
          Services & Fees
        </h2>
        <p className="text-center text-black text-lg mb-12 max-w-2xl mx-auto">
          Transparent pricing for quality English tuition tailored to your needs
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {pricing.map((item, index) => (
            <div 
              key={index} 
              className="card bg-white p-8 rounded-2xl text-center"
            >
              <h3 className="text-2xl font-semibold text-black mb-4">
                {item.level}
              </h3>
              <div className="mb-6">
                <div className="text-5xl font-bold text-black mb-2">
                  {item.price}
                </div>
                <p className="text-black opacity-70">{item.duration}</p>
              </div>
              <div className="border-t border-beige-dark pt-4">
                <ul className="space-y-2 text-sm text-black">
                  {item.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center justify-center">
                      <svg 
                        className="w-4 h-4 mr-2 text-black" 
                        fill="currentColor" 
                        viewBox="0 0 20 20"
                      >
                        <path 
                          fillRule="evenodd" 
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" 
                          clipRule="evenodd" 
                        />
                      </svg>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;